export default __webpack_public_path__ + "static/media/Boye (2).05432a20.jpg";